import React from "react";
import { useUscLabel, useUscOptionalLabel } from "../../../../../utils/labels";
import { DfVehicleStatus } from "../../../../../../shared-logic/utils/dfConstants";
import { useUscSelector } from "../../../../../redux/store";
import Badge from "../../../styles/atoms/Badge";
import Text from "../../../../../../shared-components/lexus/styles/atoms/Text";
import * as Styles from "./UscVehicleDisclaimers.styles";

const UscVehicleDisclaimers = (): JSX.Element | null => {
    const result = useUscSelector((state) => state.vehicle.result);
    const externalPriceHasError = useUscSelector((state) => state.externalPrice.failed && state.externalPrice.show);
    const vehicleAggregationsEnabled = useUscSelector((state) => state.uscSettings.enableVehicleAggregations);

    const [statusReservedLabel, statusReservedDisclaimerLabel, statusSoldLabel, statusSoldDisclaimerLabel] =
        useUscLabel([
            "uscBasketStatusReserved",
            "uscBasketStatusReservedDisclaimer",
            "uscBasketStatusSold",
            "uscBasketStatusSoldDisclaimer",
        ]);
    const externalPriceErrorLabel = useUscOptionalLabel("uscBasketTotalPriceErrorDisclaimer");
    const hubDisclaimerLabel = useUscOptionalLabel("uscBasketHubDisclaimer", {
        model: result?.product.model,
    });

    if (!result) return null;

    return (
        <>
            {externalPriceHasError && !!externalPriceErrorLabel && (
                <Text tag="div" variant="paragraph-small-book">
                    {externalPriceErrorLabel}
                </Text>
            )}

            {result.vehicleStatus.code === DfVehicleStatus.Reserved && (
                <Styles.Wrapper>
                    <Badge variant="pill">{statusReservedLabel}</Badge>
                    <Text tag="div" variant="paragraph-body-book">
                        {statusReservedDisclaimerLabel}
                    </Text>
                </Styles.Wrapper>
            )}

            {result.vehicleStatus.code === DfVehicleStatus.Sold && (
                <Styles.Wrapper>
                    <Badge variant="pill">{statusSoldLabel}</Badge>
                    <Text tag="div" variant="paragraph-body-book">
                        {statusSoldDisclaimerLabel}
                    </Text>
                </Styles.Wrapper>
            )}

            {result?.isHubCar && hubDisclaimerLabel && !vehicleAggregationsEnabled && (
                <Text tag="div" variant="paragraph-small-book">
                    {hubDisclaimerLabel}
                </Text>
            )}
        </>
    );
};

export default UscVehicleDisclaimers;
